import { render } from "./NoticesDetails.vue?vue&type=template&id=12f994f8&scoped=true"
import script from "./NoticesDetails.vue?vue&type=script&lang=js"
export * from "./NoticesDetails.vue?vue&type=script&lang=js"

import "./NoticesDetails.vue?vue&type=style&index=0&id=12f994f8&scoped=true&lang=css"

import exportComponent from "E:\\laragon\\www\\RDRS_Union_Federation\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12f994f8"]])

export default __exports__